// CONSTANTS are all caps.
const NS = "ArticleGallery";
const CLS = "articleGallery";
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/articleGallery.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class ArticleGallery {

	constructor($el) {
		// $el is the widget node return by the loadArticleGallery function
		this.$el = $($el);
	}

	init() {
		this.initArticleGallery();
	}

	initArticleGallery() {
		const $carousel = this.$el.find(`${WG}carousel`);
		const $navLinks = this.$el.find('.sliderNav-links');
		const $navPrev = this.$el.find('.sliderNav-arrow--prev');
		const $navNext = this.$el.find('.sliderNav-arrow--next');
		let navActiveClass = 'is-active';
		let navWidth = $navLinks.outerWidth();
		let navContentWidth = $navLinks.get(0).scrollWidth;
		let scrollDistance = navContentWidth - navWidth;
		let scrollPos = 0;

		$carousel.on('init', (event, slick) => {
			if (slick.slideCount <= 1) {
				$('.sliderNav').attr('hidden', '');
			}

			this.$el.find('.sliderNav-link').on('click', function () {
				let $this = $(this);
				let index = $this.attr('data-slide-index');

				$carousel.slick('slickGoTo', index);
				$this.siblings().removeClass(navActiveClass);
				$this.addClass(navActiveClass);
			});
		}).slick({
			arrows: false,
			centerMode: true,
			centerPadding: 0,
			draggable: false,
			slidesToShow: 1
		}).on('afterChange', (event, slick, currentSlide) => {
			this.$el.find(`.sliderNav-link`).removeClass(navActiveClass);
			this.$el.find(`.sliderNav-link[data-slide-index=${currentSlide}]`).addClass(navActiveClass);
		});

		$navPrev.on('click', () => {
			scrollPos = $navLinks.scrollLeft();
			if (scrollPos > 0) {
				scrollPos -= scrollDistance / 2;
				scrollPos = scrollPos < 0 ? 0 : scrollPos;
				$navLinks.animate({
					scrollLeft: scrollPos
				}, 200);
			}
		});

		$navNext.on('click', () => {
			scrollPos = $navLinks.scrollLeft();
			if (scrollPos < scrollDistance) {
				scrollPos += scrollDistance / 2;
				scrollPos = scrollPos > scrollDistance ? scrollDistance : scrollPos;
				$navLinks.animate({
					scrollLeft: scrollPos
				}, 200);
			}
		});
	}

}
